module.exports = __webpack_public_path__ + "img/Icon material-error.eb5e7577.svg";